import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import setLayout from "shared/set-layout"
import Switch from "@kaspernj/api-maker/build/router/switch"

/** @typedef {object} RoutesFrontAccountsProps */

/** @typedef {object} RoutesFrontAccountsState */

/**
 * @extends {ShapeComponent<RoutesFrontAccountsProps, RoutesFrontAccountsState>}
 */
class RoutesFrontAccounts extends ShapeComponent {
  render() {
    setLayout("front")

    return (
      <Switch name="accounts">
        <Route component="new" path="new" />
        <Route component="created" path=":account_id/created" />
      </Switch>
    )
  }
}

export default memo(shapeComponent(RoutesFrontAccounts))
